import React from 'react';
import ReportingSalesAddonsPage from '../components/ReportingSalesAddonsPage';

const ReportingSalesAddonsApp = (props) => (
  <ReportingSalesAddonsPage {...props} />
);

export default ReportingSalesAddonsApp;
